import { api } from '../apiClient'

export async function registerUser(data: { firebaseUid: string; email?: string; phone?: string; postcode?: string }): Promise<void> {
  await api.post('/api/auth/register', data)
}

export async function sendEmailCode(email: string): Promise<void> {
  await api.post('/api/auth/email/send-code', { email })
}

export async function verifyEmailCode(email: string, code: string): Promise<{ customToken: string }> {
  const res = await api.post('/api/auth/email/verify-code', { email, code })
  return res.data
}

export async function sendPhoneCode(phone: string): Promise<void> {
  await api.post('/api/auth/phone/send-code', { phone })
}

export async function verifyPhoneCode(phone: string, code: string): Promise<{ customToken: string }> {
  const res = await api.post('/api/auth/phone/verify-code', { phone, code })
  return res.data
}

export async function customerRegister(data: {
  email: string; phone?: string; password: string; jobId?: string
}): Promise<{ token: string; userId: string }> {
  const res = await api.post('/api/auth/customer/register', data)
  return res.data
}

export async function customerLogin(data: {
  email: string; password: string
}): Promise<{ token: string; userId: string }> {
  const res = await api.post('/api/auth/customer/login', data)
  return res.data
}

export async function forgotPassword(email: string): Promise<void> {
  await api.post('/api/auth/customer/forgot-password', { email })
}

export async function resetPassword(data: {
  email: string; code: string; newPassword: string
}): Promise<{ token: string }> {
  const res = await api.post('/api/auth/customer/reset-password', data)
  return res.data
}

export interface EmailLoginResponse {
  customToken?: string
  requiresOtp?: boolean
  created?: boolean
}

export async function requestEmailLogin(data: {
  email: string; phone?: string; name?: string; jobId?: string
}): Promise<EmailLoginResponse> {
  const res = await api.post('/api/auth/customer/email-login', data)
  return res.data
}

export async function verifyEmailLogin(data: {
  email: string; code: string; phone?: string; jobId?: string
}): Promise<{ customToken: string }> {
  const res = await api.post('/api/auth/customer/email-login/verify', data)
  return res.data
}
